module.exports = __webpack_public_path__ + "img/stepIcon.cef31f34.png";